import React from "react";

const EMailIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m1.964 6.428 5.817 3.879c.802.534 1.203.801 1.636.906.384.091.783.091 1.165 0 .433-.105.834-.372 1.637-.906l5.817-3.879M5.964 16.25h8.072c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.091-1.092c.273-.535.273-1.235.273-2.635v-4.5c0-1.4 0-2.1-.272-2.635a2.5 2.5 0 0 0-1.093-1.093c-.535-.272-1.235-.272-2.635-.272H5.965c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.092 1.093c-.273.535-.273 1.235-.273 2.635v4.5c0 1.4 0 2.1.272 2.635a2.5 2.5 0 0 0 1.093 1.092c.535.273 1.235.273 2.635.273"
    ></path>
  </svg>
);

export default EMailIcon;
